class BxfFormGroupConstants {
    static STRING = {
        CONTAINER: 'bxf-form-group__container',
        CONTAINER_WITH_DIVIDER: 'bxf-form-group__container--divider',
        CONTAINER_WITH_TOP_DIVIDER: 'bxf-form-group__container--top-divider',
        HEADER: 'oneds-blk-body-xs-bold',
        SPACING: 'bxf-form__spacing',
        HEADER_DISABLED: 'bxf-form-group__header-disabled',
        DISABLED: 'disabled',
    };
}

export { BxfFormGroupConstants as B };
